import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { Text } from '@wix/design-system';
import { EmptyStateBanner } from '../EmptyStateBanner';
import { useEffect } from 'react';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';

export const NoFilterResultsBanner = ({
  isMobileView,
}: {
  isMobileView?: boolean;
}) => {
  const { t } = useTranslation();
  const { logBiPageView } = useTemplatesBi({});

  const titleText = t(
    'marketplace.templates-page.empty-state.filter-no-matches-title',
  );

  useEffect(() => {
    logBiPageView({ message_text: titleText });
  }, []);

  const textSize = isMobileView ? 'small' : 'medium';

  return (
    <EmptyStateBanner title={titleText} isMobileView={isMobileView}>
      <Text size={textSize} weight="thin" secondary>
        {t('marketplace.templates-page.empty-state.filter-no-matches-subtitle')}
      </Text>
    </EmptyStateBanner>
  );
};
